/** End of a calendar day in the configured IANA display zone, stored as UTC. */
export function localDayExpiry(
  value: string,
  timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone,
): number {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value))
    throw new Error("Choose a valid expiry date");
  const [y, m, d] = value.split("-").map(Number);
  const desired = Date.UTC(y, m - 1, d, 23, 59, 59);
  if (new Date(desired).toISOString().slice(0, 10) !== value)
    throw new Error("Choose a valid expiry date");
  const formatter = new Intl.DateTimeFormat("en-GB", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  });
  let instant = desired;
  for (let i = 0; i < 4; i++) {
    const parts = Object.fromEntries(
      formatter.formatToParts(instant).map((p) => [p.type, p.value]),
    );
    const wall = Date.UTC(
      Number(parts.year),
      Number(parts.month) - 1,
      Number(parts.day),
      Number(parts.hour),
      Number(parts.minute),
      Number(parts.second),
    );
    if (wall === desired) return instant / 1000;
    instant += desired - wall;
  }
  throw new Error("That calendar day is unavailable in your display timezone");
}
